import { h, render } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import './index.scss';
import configs from './config.json';

const Calculator = () => {
  const { orderServiceTypes } = configs;
  const [settings, setSettings] = useState({
    orderServiceType: 45,
    discipline: 24,
    deadline: 25,
    orderLink: '',
    title: '',
  });
  const [defaultDiscipline, setDefaultDiscipline] = useState(24);

  const renderedOrderServiceTypes = orderServiceTypes.map(item => {
    return (
      <option key={item.id} value={item.id} selected={+item.id === +settings?.orderServiceType}>
        {item.name}
      </option>
    );
  });

  useEffect(() => {
    const $settings = document.querySelector('[data-settings]');
    const configFromAdminPanel = JSON.parse($settings?.dataset?.settings);
    setSettings({ ...siteConfiguration, ...configFromAdminPanel });

    setTimeout(() => {
      const elem = document.querySelector('.calc-short');
      elem.style.visibility = 'visible';
      elem.style.opacity = '1';
    }, 400);
  }, []);

  function renderSelects() {
    const { configsForCalculations, configsForProgramming, disciplines } = configs;

    // todo: optimize
    switch (Number(settings.orderServiceType)) {
      case 45:
        return {
          deadlines: configsForCalculations.deadlines.map(deadline => {
            return (
              <option
                key={deadline.id}
                value={deadline.id}
                selected={Number(deadline.id) === Number(settings.deadline) ? 'selected' : ''}
              >
                {deadline.name}
              </option>
            );
          }),
          disciplines: disciplines.map((discipline, id) => {
            if (configsForCalculations.disciplinesIds.includes(discipline.id)) {
              return (
                <option
                  selected={Number(settings.discipline) === Number(discipline.id) ? 'selected' : ''}
                  value={discipline.id}
                >
                  {discipline.name}
                </option>
              );
            }
          }),
        };
      case 46:
        return {
          deadlines: configsForProgramming.deadlines.map(deadline => {
            return (
              <option
                key={deadline.id}
                value={deadline.id}
                selected={Number(deadline.id) === Number(settings.deadline)}
              >
                {deadline.name}
              </option>
            );
          }),
          disciplines: disciplines
            // eslint-disable-next-line array-callback-return,consistent-return
            .filter(discipline => {
              if (configsForProgramming.disciplinesIds.includes(discipline.id)) {
                return discipline;
              }
            })
            .map(d => {
              return (
                <option
                  selected={
                    (settings.discipline || Number(configsForProgramming.defaults.disciplineId)) ===
                    Number(d.id)
                  }
                  value={d.id}
                >
                  {d.name}
                </option>
              );
            }),
        };
      default:
        return {
          deadlines: configsForCalculations.deadlines.map(deadline => {
            return (
              <option
                key={deadline.id}
                value={deadline.id}
                selected={Number(deadline.id) === Number(settings.deadline) ? 'selected' : ''}
              >
                {deadline.name}
              </option>
            );
          }),
          // eslint-disable-next-line array-callback-return,consistent-return
          disciplines: disciplines.map((discipline, id) => {
            if (configsForCalculations.disciplinesIds.includes(discipline.id)) {
              return (
                <option
                  selected={Number(settings.discipline) === Number(discipline.id) ? 'selected' : ''}
                  value={discipline.id}
                >
                  {discipline.name}
                </option>
              );
            }
          }),
        };
    }
  }

  function submitHandler() {
    window.location.href = `${settings.orderLink}?orderServiceTypeId=${settings.orderServiceType}&deadlineId=${settings.deadline}&topcatId=${settings.discipline}`;
  }

  return (
    <div className="calc-short" data-calc-short>
      <form name="calculator" className="Calc" data-calculator-form>
        <div className="section-top__calc__heading h3">{settings?.title}</div>
        <div className="Calc__wrapper">
          <div className="Calc__row">
            <label className="Calc__label select select--icon" htmlFor="calc-paperTypeId">
              <span className="select-icon select-icon--type-of-paper"></span>
              <span className="Calc__label-title">Type of service</span>
              <select
                id="calc-paperTypeId"
                name="paperTypeId"
                value={settings.orderServiceType}
                onChange={e =>
                  setSettings(prevState => ({
                    ...prevState,
                    orderServiceType: Number(e.target.value),
                  }))
                }
              >
                {renderedOrderServiceTypes}
              </select>
            </label>
          </div>
          <div className="Calc__row">
            <label className="Calc__label select--icon select">
              <span className="select-icon select-icon--academic-level"></span>
              <span className="Calc__label-title">Discipline</span>
              <select
                id="2select"
                className="sfrom-select-level"
                name="academicLevelId"
                // value={defaultDiscipline}
                onChange={e => {
                  setSettings(prevState => ({
                    ...prevState,
                    discipline: Number(e.target.value),
                  }));
                }}
              >
                {renderSelects()?.disciplines}
              </select>
            </label>
          </div>
          <div className="Calc__row Calc__row--deadline">
            <label className="Calc__label select select--icon" htmlFor="calc-deadlineId">
              <span className="select-icon select-icon--deadline"></span>
              <span className="Calc__label-title">Deadline</span>
              <select
                id="calc-deadlineId"
                className="sfrom-select-deadline"
                name="deadlineId"
                autocomplete="off"
                onChange={e => {
                  setSettings(prevState => ({
                    ...prevState,
                    deadline: Number(e.target.value),
                  }));
                }}
              >
                {renderSelects()?.deadlines}
              </select>
            </label>
          </div>
          <div className="Calc__row Calc__submit">
            <button
              type="submit"
              className="btn btn--orange"
              id="continue-to-order"
              onClick={e => {
                e.preventDefault();
                submitHandler();
              }}
            >
              Continue to order
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

document.addEventListener('DOMContentLoaded', () => {
  const $element = document.querySelector('#calculator-el .calculator');
  if ($element) render(<Calculator />, $element);
});
